import {GUEST_THEME_STORAGE_KEY} from '@toolify/client/src/modules/authentication/constants/guestAppearanceStorageKeys'

export function getStoredGuestTheme(): string | undefined {
  if(typeof localStorage === 'undefined') {
    return undefined
  }
  return localStorage.getItem(GUEST_THEME_STORAGE_KEY) || undefined
}
